/**
 * @generated SignedSource<<ee065864dead300f57e568398ac54905>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsEmailTab_account$data = {
  readonly id: string;
  readonly inboundLocalPart: string | null;
  readonly inboundEmailDomain: string | null;
  readonly supportEmailDomainConfigured: boolean | null;
  readonly autoReply: {
    readonly enabled: boolean;
    readonly fromName: string;
    readonly fromEmail: string;
    readonly bodyHtml: string;
    readonly resolvedEnabled: boolean;
    readonly resolvedFromName: string;
    readonly resolvedFromEmail: string;
    readonly resolvedBodyHtml: string;
  } | null;
  readonly " $fragmentType": "SettingsEmailTab_account";
};
export type SettingsEmailTab_account$key = {
  readonly " $data"?: SettingsEmailTab_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"SettingsEmailTab_account">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SettingsEmailTab_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inboundLocalPart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inboundEmailDomain",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportEmailDomainConfigured",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AutoReplyConfig",
      "kind": "LinkedField",
      "name": "autoReply",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fromName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fromEmail",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bodyHtml",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "resolvedEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "resolvedFromName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "resolvedFromEmail",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "resolvedBodyHtml",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TicketingAccount",
  "abstractKey": null
};

(node as any).hash = "fe9267c720b48da289a85a0598c4aa51";

export default node;
